import { useMemo } from 'react';
import {
  Alert,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';

const MIME_OPTIONS = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'video/mp4',
];

export function MediaUploadNodeFields({ localNodeData, updateNodeData, accountList }) {
  const accountId = localNodeData?.AccountId ?? '';
  const inputVarKey = localNodeData?.InputVarKey ?? '';
  const outputKey = localNodeData?.OutputKey ?? '';

  const missingAccountId = !accountId;
  const missingInputVarKey = !String(inputVarKey || '').trim();
  const missingOutputKey = !String(outputKey || '').trim();

  const hasErrors = missingAccountId || missingInputVarKey || missingOutputKey;

  const mediaTypeValue = useMemo(() => {
    const v = localNodeData?.MediaType;
    return v === undefined || v === null ? '' : String(v);
  }, [localNodeData?.MediaType]);

  return (
    <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Media Upload
      </Typography>

      {hasErrors ? (
        <Alert severity="warning">
          {missingAccountId ? 'AccountId es requerido. ' : ''}
          {missingInputVarKey ? 'InputVarKey es requerido. ' : ''}
          {missingOutputKey ? 'OutputKey es requerido.' : ''}
        </Alert>
      ) : null}

      <FormControl fullWidth size="small" error={missingAccountId}>
        <InputLabel id="mediaupload-account-label">Cuenta / Teléfono</InputLabel>
        <Select
          labelId="mediaupload-account-label"
          label="Cuenta / Teléfono"
          variant="outlined"
          value={accountId}
          onChange={(e) => {
            const value = e.target.value;
            // Guardar como number si viene numérico
            const asNumber = value === '' ? '' : Number(value);
            updateNodeData('AccountId', Number.isNaN(asNumber) ? value : asNumber);
          }}
        >
          {(accountList || []).map((acc) => (
            <MenuItem key={acc.id} value={acc.id}>
              {acc.number || acc.name || acc.id}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        size="small"
        label="Variable Base64 (InputVarKey)"
        placeholder="pdf o document_base64"
        value={inputVarKey}
        error={missingInputVarKey}
        onChange={(e) => updateNodeData('InputVarKey', e.target.value)}
      />

      <TextField
        size="small"
        label="Guardar media_id en (OutputKey)"
        placeholder="pdf_media_id"
        value={outputKey}
        error={missingOutputKey}
        onChange={(e) => updateNodeData('OutputKey', e.target.value)}
      />

      <TextField
        select
        size="small"
        label="MIME type (MediaType)"
        value={mediaTypeValue}
        onChange={(e) => updateNodeData('MediaType', e.target.value)}
        helperText="Opcional. Si no aplica, dejar vacío."
      >
        <MenuItem value="">(vacío)</MenuItem>
        {MIME_OPTIONS.map((m) => (
          <MenuItem key={m} value={m}>
            {m}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        size="small"
        label="Nombre de archivo (Filename)"
        placeholder="documento.pdf / foto.jpg"
        value={localNodeData?.Filename || ''}
        onChange={(e) => updateNodeData('Filename', e.target.value)}
        helperText="Opcional."
      />

      <TextField
        size="small"
        label="Copiar Base64 a (PersistInputVarKey)"
        placeholder="pdf_backup"
        value={localNodeData?.PersistInputVarKey || ''}
        onChange={(e) => updateNodeData('PersistInputVarKey', e.target.value)}
        helperText="Opcional."
      />
    </Box>
  );
}
